import { render } from "./ClassSessionAdder.vue?vue&type=template&id=4a567df9&scoped=true"
import script from "./ClassSessionAdder.vue?vue&type=script&lang=js"
export * from "./ClassSessionAdder.vue?vue&type=script&lang=js"

import "./ClassSessionAdder.vue?vue&type=style&index=0&id=4a567df9&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a567df9"]])

export default __exports__